
// const baseUrl = 'http://gwapiv3.klch.cn' //预上线接口
// const baseUrl = 'http://172.17.3.250:5510' //测试接口

const baseUrl = 'https://gwapiv2.klch.cn' //正式接口
export default {
  GetSiteData: baseUrl + '/api/CompanySite/GetSiteData', //seo关键字
  GetNewsPageData: baseUrl + '/api/CompanyNews/GetNewsPageData', //新闻列表
  GetMediaPageData: baseUrl + '/api/CompanyMedia/GetMediaPageData', //主题活动数据 MediaType：1视频集锦2图文展示
  GetNewsPageData: baseUrl + '/api/CompanyNews/GetNewsPageData', //新闻详情
  GetHistoryPageData: baseUrl + '/api/CompanyHistory/GetHistoryPageData', //发展历程
  GetCompanyTeamData: baseUrl + '/api/CompanyTeam/GetCompanyTeamData', //管理团队
  GetCorporateHonorsData: baseUrl + '/api/CorporateHonors/GetCorporateHonorsData', //荣誉证书
  GetCompanyVisionData: baseUrl + '/api/CompanyVision/GetCompanyVisionData', //视角
  GetHZGYMediaData: baseUrl + '/api/CompanyMedia/GetHZGYMediaData', //合作共赢页面
  GetFCLYMediaData: baseUrl + '/api/CompanyMedia/GetFCLYMediaData', //房车露营页面
  GetCQWLMediaData: baseUrl + '/api/CompanyMedia/GetCQWLMediaData', //沉侵文旅页面
  GetCompanyYCTYData: baseUrl + '/api/CompanyYCTY/GetCompanyYCTYData', //远程天翼发展历程
  GetMediaDataById: baseUrl + '/api/CompanyMedia/GetMediaDataById', //图文展示
  GetVisionDataById: baseUrl + '/api/CompanyVision/GetVisionDataById', //视角详情
  GetCompanyRVCampingDataById: baseUrl + '/api/CompanyRVCamping/GetCompanyRVCampingDataById', //营地案例
  GetCompanyCQWLDataById: baseUrl + '/api/CompanyCQWL/GetCompanyCQWLDataById', //剧本详情
  GetCompanyScenicSpotDataById: baseUrl + '/api/CompanyScenicSpot/GetCompanyScenicSpotDataById', //景区详情
  GetCompanyALCampingDataById: baseUrl + '/api/CompanyALCamping/GetCompanyALCampingDataById', //营地案例
}



// WEBPACK FOOTER //
// ./src/api/api.js